import { axiosInstance } from '@/modules/shared/lib/axios'
import { RemoveCompaniesFromGroupRequest } from './types'

type Props = {
  companyId: string
  payload: RemoveCompaniesFromGroupRequest
}

export function removeCompaniesFromGroup({ companyId, payload }: Props) {
  return axiosInstance.post(
    `/config-api/${companyId}/configuration/admin/companies/removeCompaniesFromGroup`,
    payload
  )
}
